import { useState, useEffect } from "react";
import { ReactComponent as SubMenuIcon } from "../../assets/icons/sideBarIcon.svg";
import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory } from "react-router-dom";
import { GetSale } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const SalesSideBar = ({ activeTab, subMenuItem, saleID }) => {
  const [regName, setRegName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const redirectTo = (link) => {
    window.location.href = link;
  };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  const subMenu = () => {
    if (hideUnHideSubMenu === "A") {
      sethideUnHideSubMenu("I");
    } else {
      sethideUnHideSubMenu("A");
    }
  };

  const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState("A");

  useEffect(() => {
    const fetchSalesMeta = async () => {
      try {
        const response = await GetSale();
        const saleItems = response.data?.sales || response.data?.Sale || response.data?.result || [];
        const saleArray = Array.isArray(saleItems) ? saleItems : [saleItems];
        const matchedSale = saleArray.find(
          (item) =>
            item &&
            (item._id === saleID || item.id === saleID || item.saleID === saleID)
        );
        const selectedSale = matchedSale || saleArray[0];
        if (selectedSale) {
          setRegName(selectedSale.regname || selectedSale.name || "Sales Register");
          setCompanyName(
            selectedSale.companyData?.company_name ||
            selectedSale.companyData?.companyName ||
            selectedSale.company_name ||
            ""
          );
        }
      } catch (error) {
        console.error("Failed to load sales sidebar metadata:", error);
      }
    };

    fetchSalesMeta();
  }, [saleID]);

  const menuItems = [
    { key: 1, label: "Dashboard", pagelink: `/myfinV2/sales/dashboard` },
    // {
    //   key: 2,
    //   label: "Lorem Ipsum",
    //   pagelink: `/myfinV2/sales/samplepage1`,
    // },
    // { key: 3, label: "Lorem Ipsum", pagelink: `/myfinV2/sales/samplepage2` },
    // { key: 4, label: "Lorem Ipsum", pagelink: `/myfinV2/sales/samplepage3` },
    {
      key: 2,
      label: "Listing",
      pagelink: saleID ? `/myfinV2/sales/listing/${saleID}` : `/myfinV2/sales/listing`,
    },
  ];

  const activeItem = activeTab;
  const activeItemSubMenu = subMenuItem;

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div className={sidemenucss.sidemenuHeader}>
        <span className={sidemenucss.sidemenuTitlePS}>{regName || "Sales Register"}</span>
        <div style={{ textAlign: 'left' }}>
          <p className={sidemenucss.companyText} >
            {companyName || "Company"}
          </p>
        </div>
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                onClick={() => {
                  subMenu();
                  if (item.pagelink) {
                    setTimeout(() => handleClick(item.pagelink), 100);
                  }
                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === item.label
                    ? sidemenucss.sidemenuItemActive
                    : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                    <div className={sidemenucss.submenuIcon}>
                      {item.subMenu ? (
                        <SubMenuIcon
                          className={`${sidemenucss.submenuIconSvg} ${
                            hideUnHideSubMenu === "A"
                              ? null
                              : sidemenucss.rotatedIcon
                          }`}
                        />
                      ) : null}
                    </div>
                  </div>
                </span>
              </li>
              {item.subMenu ? (
                <div
                  className={`${sidemenucss.submenuContainer} ${
                    hideUnHideSubMenu === "A"
                      ? sidemenucss.sideMenuShow
                      : sidemenucss.sideMenuHide
                  }`}
                >
                  {item.subMenu.map((sub, idx) => (
                    <div
                      key={idx}
                      className={`${sidemenucss.submenuItem} ${
                        activeItemSubMenu === sub.label
                          ? sidemenucss.activeSubMenu
                          : null
                      }`}
                      onClick={() => handleClick(sub.link)}
                    >
                      {sub.label}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SalesSideBar;
